


















































































import { Component, Vue } from "vue-property-decorator";
import LogoRow from "@/components/LogoRow.vue";
import AppFooter from "@/components/AppFooter.vue";
import * as backend from "@/domain/backend";

@Component({
  components: { LogoRow, AppFooter }
})
export default class AuthReinforce extends Vue {
  code = "";
  isLoading = false;
  errorMsg = "";
  resendCountdown = 30;
  resendTimer: number | null = null;
  skipConfirm = false;

  // Read live from the store (not copied into local data on created) so there is no
  // race with whichever screen redirected here and committed the notice.
  get noticeMsg(): string {
    return this.$store.state.reinforcedLoginNotice;
  }

  created() {
    if (!this.$store.state.needsReinforcedLogin) {
      this.$store.dispatch("finishSignIn");
      return;
    }
    this.startResendTimer();
  }

  beforeDestroy() {
    if (this.resendTimer !== null) {
      clearInterval(this.resendTimer);
    }
    // The notice is scoped to a single visit to this screen.
    this.$store.commit("setReinforcedLoginNotice", "");
  }

  startResendTimer() {
    this.resendCountdown = 30;
    this.resendTimer = setInterval(() => {
      if (this.resendCountdown > 0) {
        this.resendCountdown--;
      } else if (this.resendTimer !== null) {
        clearInterval(this.resendTimer);
      }
    }, 1000) as unknown as number;
  }

  async cmdVerify() {
    if (this.code.length < 4) return;
    await this.verifyCode(this.code);
  }

  async verifyCode(code: string | null) {
    if (this.isLoading) return;
    this.errorMsg = "";
    this.isLoading = true;
    try {
      await this.$store.dispatch("completeReinforcedLogin", code);
    } catch (err) {
      this.errorMsg = (err as Error).message;
    }
    this.isLoading = false;
  }

  async cmdSkip() {
    this.skipConfirm = false;
    await this.verifyCode(null);
  }

  async cmdResend() {
    this.errorMsg = "";
    this.isLoading = true;
    try {
      await backend.reinforceSend();
      this.startResendTimer();
    } catch (err) {
      this.errorMsg = (err as Error).message;
    }
    this.isLoading = false;
  }
}
